import React from "react";
import {BooleanRadioButton, BooleanRadioButtonGroup} from "@octopusdeploy/design-system-components";
import {DataBaseComponent, DataBaseComponentState, Errors} from "~/components/DataBaseComponent";
import {BusyState} from "~/components/BusyFromPromise/BusyFromPromise";
import {HostedInstanceResource} from "~/client/resources/hostedInstanceResource";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import repository from "~/client/repository";
import {
    HostedInstanceRotateRedisCachePasswordRequest
} from "~/client/resources/HostedInstanceRotateRedisCachePasswordRequest";

interface Props {
    errors: Errors;
    busy: BusyState;
    instance: HostedInstanceResource;
    onSaveClick(): Promise<boolean>;
}

interface State extends DataBaseComponentState {
    rotateRedisCachePasswordRequest: Partial<HostedInstanceRotateRedisCachePasswordRequest>;
}


export class RotateRedisCachePasswordDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            rotateRedisCachePasswordRequest: {
                ApplyDuringMaintenanceWindow: true
            },
        };
    }

    render() {
        const request = this.state.rotateRedisCachePasswordRequest;
        return <SaveDialogLayout title={"Rotate Redis cache password"}
                                 errors={this.state.errors}
                                 busy={this.state.busy}
                                 onSaveClick={() => this.rotateRedisCachePassword(request)}>

            <BooleanRadioButtonGroup value={this.state.rotateRedisCachePasswordRequest.ApplyDuringMaintenanceWindow}
                              onChange={ApplyDuringOutage => this.updateRotateRedisCachePasswordRequest({ApplyDuringMaintenanceWindow: ApplyDuringOutage})}>
                <BooleanRadioButton value={true} label="Apply During Outage Window"/>
                <BooleanRadioButton value={false} label="Apply Immediately"/>
            </BooleanRadioButtonGroup>
        </SaveDialogLayout>;
    }

    private updateRotateRedisCachePasswordRequest(update: Partial<HostedInstanceRotateRedisCachePasswordRequest>) {
        return this.setState(prevState => ({rotateRedisCachePasswordRequest: {...prevState.rotateRedisCachePasswordRequest, ...update}}));
    }

    private async rotateRedisCachePassword(request: Partial<HostedInstanceRotateRedisCachePasswordRequest>) {
        return await this.doBusyTask(async () => {
            await repository.HostedInstances.rotateRedisCachePassword(this.props.instance, request as HostedInstanceRotateRedisCachePasswordRequest);
            await this.props.onSaveClick();
            return true;
        });
    }
}
